<template>
  <div class="info">
    <span
      class="info__icon"
      :style="{
        color: color,
        border: `1px solid ${color}`,
      }"
      @mouseover="showDescription = true"
      @mouseleave="showDescription = false"
      >i</span
    >
    <transition name="fade">
      <div v-if="showDescription && tooltip" class="info__description">
        {{ description }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    tooltip: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: 'V4: describe the information here, with "description" prop.',
    },
    color: {
      type: String,
      default: '#94D6DA',
    },
  },
  data() {
    return {
      showDescription: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.info {
  position: relative;
  display: flex;
  align-items: center;

  &__icon {
    border-radius: 50%;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15px;
    height: 15px;
    font-size: 12px;
    cursor: pointer;
  }

  &__description {
    position: absolute;
    width: 250px;
    overflow: auto;
    margin-top: 160px;
    background: rgba(black, 0.8);
    color: white;
    border-radius: 10px;
    padding: 15px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    direction: ltr;
    z-index: 1000;
  }
}
</style>
